module.exports = __webpack_public_path__ + "img/colleagues-giving-fist-bump.f4bb060e.png";